export class ViewVehicle {

  public remitoType: string | null;
  public remitoTypeField: string | null;
  public clase: string | null;
  public ptoEmision: string | null;
  public nroRemito: string;
  public pdfName: string | null;
  public codOrigen: string;
  public descOrigen: string | null;
  public codDestino: string | null;
  public nombreDestino: string | null;
  public codTransp: string | null;
  public nombreTransp: string | null;
  public fecGen: Date | null;
  public fechaDeEnvio: Date | null;
  public estadoRemito: string | null;
  public impresorasCode: string | null;
  public impresoraField: string = '';
  public vinLetras: string | null;
  public vinNumeros: string | null;
  public cancelarObservacion: string | null;
  public cancelarFecha: Date | null;

  static transformViewVehicle(data: any): ViewVehicle {
    let viewVehicle = new ViewVehicle();
    viewVehicle.remitoType = data.remitoType;
    viewVehicle.remitoTypeField = this.getTipo(data.remitoType);
    viewVehicle.clase = data.clase.toUpperCase();
    viewVehicle.ptoEmision = data.ptoEmision;
    viewVehicle.nroRemito = data.nroRemito.toString();
    viewVehicle.pdfName = data.pdfName;
    viewVehicle.codOrigen = data.codOrigen;
    viewVehicle.descOrigen = data.descOrigen;
    viewVehicle.codDestino = data.codDestino;
    viewVehicle.nombreDestino = data.nombreDestino;
    viewVehicle.codTransp = data.codTransp;
    viewVehicle.nombreTransp = data.nombreTransp;
    viewVehicle.estadoRemito = data.estadoRemito;
    viewVehicle.impresorasCode = "";
    viewVehicle.impresoraField = "";
    viewVehicle.vinLetras = data.vinLetras;
    viewVehicle.vinNumeros = data.vinNumeros;

    if (data.cancelarObservacion != undefined) {
      viewVehicle.cancelarObservacion = data.cancelarObservacion;
      viewVehicle.cancelarFecha = new Date(data.cancelarFecha);
    }

    if (data.fecGen != undefined) {
      viewVehicle.fecGen = new Date(data.fecGen);
    }

    if (data.fechaDeEnvio != undefined) {
      viewVehicle.fechaDeEnvio = new Date(data.fechaDeEnvio);
    }

    return viewVehicle;
  }

  static getTipo(tipo: string) {
    if (tipo.toUpperCase() == 'M') {
      return "Manual";
    } else if (tipo.toUpperCase() == 'A') {
      return "Automatic";
    } else {
      return tipo;
    }
  }
}

export class ViewVin {
  public id: number | null;
  public vinLetras: string | null;
  public vinNumeros: string | null;
  public anioModelo: string | null;
  public descModelo: string | null;
  public descVehiculo: string | null;
  public colorExt: string | null;
  public colorInt: string | null;
  public nroMotor: string | null;
}
